import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const shiftEventsCrudActionTypes = generateEntityCrudActionTypes('shiftEvents')

export default { ...shiftEventsCrudActionTypes }
